import { useDispatch, useSelector } from 'react-redux';

import { isolatedDiscardVehicle } from 'Core/actions/fitmentSearch/index.js';
import { discardField } from 'Core/actions/request.js';
import {
  createResponseVehicleSelector,
  isVehicleSelectedSelector,
} from 'Core/selectors/fitmentSearch/index.js';
import fitmentSearchConfig from 'Models/uiConfig/fitmentSearchConfig.js';
import FacetToggle from 'Components/smallComponents/facetToggle.tsx';
import { cloneSafe } from 'Utils/components.ts';

export default function VehicleLabel({
  template,
  appendedClasses,
  rootRef,
  isolatedKey,
  onChangeVehicle,
  openDialog,
  facetToggleConfig,
  globalVehicleDiscardEnabled,
  templateName,
}) {
  const dispatch = useDispatch();

  const displayedVehicle = useSelector(createResponseVehicleSelector(isolatedKey));
  const isVehicleSelected = useSelector(isVehicleSelectedSelector);

  const discardVehicle = () => {
    dispatch(discardField('Universal', { stayOnPage: true, sendRequest: false }));
    dispatch(isolatedDiscardVehicle(isolatedKey, globalVehicleDiscardEnabled));
    onChangeVehicle();
    fitmentSearchConfig.onVehicleDiscarded();
  };

  const facetToggle = (templ) => {
    if (!facetToggleConfig) {
      return null;
    }

    const props = {
      template: templ,
      key: 'facet-toggle',
      ...facetToggleConfig,
    };

    return <FacetToggle {...props} />;
  };

  const params = {
    template: templateName,
    isVehicleSelected,
    fitmentSearchTitle: fitmentSearchConfig.fitmentSearchTitle,
    vehicle: displayedVehicle.filteredFieldMap,
    vehicleString: displayedVehicle.toString(),
    vehicleValues: displayedVehicle.serializable,
    changeVehicle: onChangeVehicle,
    discardVehicle,
    facetToggle,
    openDialog,
  };
  const component = template.call(params);

  return cloneSafe(component, rootRef, { appendedClasses });
}
